<template>
  <div class="content-body">
    <loader ref="loader" />
    <div class="content-body__title">
      {{ $t('expiry-modals.sessionTimeout') }}

    </div>
    <div class="content-body__text">
      {{ $t('expiry-modals.sessionExpiredOTP', { email: getEmailSubstring() }) }}

    </div>

    <div class="content-body__button-box">
      <custom-button
          @handle-click="generateNewTokenWithOTP()"
          :name="$t('expiry-modals.ok')"
          class="w-50 content-body__button mt-2"
        />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PASSWORDLESS_SIGNIN } from '../../store/modules/auth/consts';
import { routeEnum } from '../../store/modules/auth/enum';
import CustomButton from "../../views/customButton.vue";
export default {
  props: {
    marginTop: Boolean,
  },
  components: {
    CustomButton
  },
  computed: {
    ...mapGetters({
      sessionNotifyStatus: 'user/sessionNotifyStatus',
    }),
  },
  mounted() {
    this.$refs.loader.end();
  },
  data() {
    return {
      loader: false,
    }
  },
  methods: {
    showLoader() {
      this.$refs.loader.start();
    },
    setBankLinkedMutation(val) {
      if (!val.isBankLinked) {
        return;
      }
      this.$store.commit(
        'user/setSessionNotifyStatus',
        {
          isBankLinked: true,
        },
      );
    },
    async generateNewTokenWithOTP() {
      try {
        this.loader = true;
        const { email } = this.sessionNotifyStatus.data;
        if (this.$route.name === routeEnum.SIGN_IN) {
          this.$store.commit(
            'user/setSessionNotifyStatus',
            { active: false },
          );
          this.loader = false;
          return;
        }
        // check email
        if (!email) { // redirect to signin if no email is available
          this.loader = false;
          this.$router.push({ name: routeEnum.SIGN_IN });
          return;
        }

        window.EventBus.on('MAGICLINK_FLOW_COMPLETE', this.showLoader);
        window.EventBus.on('BANK_CONNECTED_ALERT', this.setBankLinkedMutation);

        const result = await this.$store.dispatch(`auth/${PASSWORDLESS_SIGNIN}`, {
          email,
          request: {
            encryptedReq: this.encryptStringWithRSA(JSON.stringify(
              { email },
            )),
          },
        });

        if (this.$store.getters['user/sessionNotifyStatus'].active) {
          this.$store.commit(
            'user/setSessionNotifyStatus',
            { active: false },
          );
        }

        if (result) {
          this.$emit('force-rerender', true);
          this.loader = false;
          return;
        }
        this.loader = false;
        this.$router.push({ name: routeEnum.SIGN_IN });
      } catch (err) {
        this.loader = false;
        console.log(err)
      }
    },
    getEmailSubstring(length = 2) {
      return this.sessionNotifyStatus.data?.email?.substr(0, length) || '__';
    },
  },
};
</script>
<style lang="scss" scoped>
.content-body {
  width: 70%;
  min-height: 130px;
  margin: auto;
  z-index: 750;
  background-color: #fff;
  padding: 20px;

  &__title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  &__text {
    text-align: center;
    font-size: 14px;
  }

  &__button-box {
    display: flex;
    justify-content: center;
  }

  &__button {
    background: #f0833c;
    border: none;
    outline: none;
  }

}
</style>
